export default __webpack_public_path__ + "static/media/vlcsnap-2021-10-19-09h06m37s521.6753d701.jpg";